import { theme } from "@/theme/theme";

/** Shared color palette for uptime/status-page components */
export const UPTIME_COLORS = {
  operational: theme.palette.success.main,
  degraded: theme.palette.warning.main,
  outage: theme.palette.error.main,
  unknown: theme.palette.text.secondary,
  no_data: theme.palette.text.disabled,
} as const;
